import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import DashboardLayout from "@/layouts/DashboardLayout";
import DashboardHome from "@/pages/DashboardHome";
import CompanyPage from "@/pages/CompanyPage";
import TerritoriesPage from "@/pages/TerritoriesPage";
import TeamPage from "@/pages/TeamPage";
import ConnectionsPage from "@/pages/ConnectionsPage";
import PublicationsPage from "@/pages/PublicationsPage";
import KnowledgePage from "@/pages/KnowledgePage";
import KeywordsPage from "@/pages/KeywordsPage";
import ContentPage from "@/pages/ContentPage";
import CoveragePage from "@/pages/CoveragePage";
import CampaignsPage from "@/pages/CampaignsPage";
import SeasonalPage from "@/pages/SeasonalPage";
import CreativeStudioPage from "@/pages/CreativeStudioPage";
import CalendarPage from "@/pages/CalendarPage";
import AnalyticsPage from "@/pages/AnalyticsPage";
import LeadsPage from "@/pages/LeadsPage";
import GuidesPage from "@/pages/GuidesPage";
import ClientsPage from "@/pages/platform/ClientsPage";
import MigrationPage from "@/pages/platform/MigrationPage";
import LeadFormPage from "@/pages/public/LeadFormPage";
import GuidePage from "@/pages/public/GuidePage";
import BioPage from "@/pages/public/BioPage";
import PrivacyPage from "@/pages/public/PrivacyPage";
import TermsPage from "@/pages/public/TermsPage";
import LandingPage from "@/pages/public/LandingPage";
import "@/App.css";

function AppRouter() {
  const location = useLocation();
  // Detectar el session_id del fragmento ANTES de cualquier ruta protegida.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<Login />} />
      <Route path="/l/:code" element={<LeadFormPage />} />
      <Route path="/g/:slug" element={<GuidePage />} />
      <Route path="/b/:slug" element={<BioPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route
        path="/dashboard"
        element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}
      >
        <Route index element={<DashboardHome />} />
        <Route path="leads" element={<LeadsPage />} />
        <Route path="guides" element={<GuidesPage />} />
        <Route path="company" element={<CompanyPage />} />
        <Route path="territories" element={<TerritoriesPage />} />
        <Route path="team" element={<TeamPage />} />
        <Route path="connections" element={<ConnectionsPage />} />
        <Route path="publications" element={<PublicationsPage />} />
        <Route path="knowledge" element={<KnowledgePage />} />
        <Route path="keywords" element={<KeywordsPage />} />
        <Route path="content" element={<ContentPage />} />
        <Route path="coverage" element={<CoveragePage />} />
        <Route path="campaigns" element={<CampaignsPage />} />
        {/* Prompt 49 (2026-10-09): blogs por temporada desde Search Console */}
        <Route path="seasonal" element={<SeasonalPage />} />
        <Route path="creative-studio" element={<CreativeStudioPage />} />
        <Route path="calendar" element={<CalendarPage />} />
        <Route path="analytics" element={<AnalyticsPage />} />
        <Route path="clients" element={<ClientsPage />} />
        <Route path="migration" element={<MigrationPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
